import React from 'react';

import { IIconProps, TIconType } from '../interface';

const AccessPointIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='access-point-icon'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<g clipPath='url(#clip0_41_2049)'>
				<circle
					cx='12'
					cy='12'
					fill={props?.color || 'currentColor'}
					r='12'
				/>
				<path
					d='M8 6C8 5.44772 8.44772 5 9 5H15C15.5523 5 16 5.44772 16 6V18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18V6Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_41_2049'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default AccessPointIcon;
